var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0773 10.4814L16.9129 6.64582C17.2926 6.26613 17.2926 5.65052 16.9129 5.27082C16.5333 4.89113 15.9176 4.89113 15.5379 5.27082L10.4569 10.3518C10.099 10.7098 10.099 11.2902 10.4569 11.6482L15.5379 16.7292C15.9176 17.1088 16.5333 17.1088 16.9129 16.7292C17.2926 16.3495 17.2926 15.7338 16.9129 15.3542L13.0773 11.5185C12.791 11.2322 12.791 10.7678 13.0773 10.4814Z",
    fill: "#1EF5DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57733 10.4814L11.4129 6.64582C11.7926 6.26613 11.7926 5.65052 11.4129 5.27082C11.0333 4.89113 10.4176 4.89113 10.0379 5.27082L4.95697 10.3518C4.59898 10.7098 4.59898 11.2902 4.95697 11.6482L10.0379 16.7292C10.4176 17.1088 11.0333 17.1088 11.4129 16.7292C11.7926 16.3495 11.7926 15.7338 11.4129 15.3542L7.57733 11.5185C7.29095 11.2322 7.29095 10.7678 7.57733 10.4814Z",
    fill: "#1EF5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleRight);
export default __webpack_public_path__ + "static/media/toggle_right.271f3be96d164218e50e8244895e8df3.svg";
export { ForwardRef as ReactComponent };